import React from "react";
import WelcomePage from "components/WelcomePage";
import Donors from "components/Donors";

const Home: React.FC = () => {
  return (
    <div>
      <WelcomePage />
      <div
        style={{
          position: "relative",
          zIndex: 4,
          backgroundColor: "var(--color-bg-darker)",
        }}
      >
        <Donors />
      </div>
    </div>
  );
};

export default Home;
